<div class="top-app-bar-container">
    <div *ngIf="showPageHeader()" class="header">
        <!-- Leading Icon: Conditionally hide based on search state -->
        <div class="leading-icon" *ngIf="!searchComp?.searchActive()">
            <button *ngIf="showMenuIcon()" class="normalized-button" (click)="isBulkMobileActive() ? triggerBulkExit() : toggleSidebarOpen('navbar')" mat-icon-button>
                <mat-icon>{{ isBulkMobileActive() ? 'close' : 'menu' }}</mat-icon>
            </button>
            <button *ngIf="showGoBackIcon()" class="normalized-button" (click)="goBack()" mat-icon-button>
                <mat-icon class="payment-back-arrow" dir="ltr">{{ backArrowIcon }}</mat-icon>
            </button>
        </div>

        <!-- Headline: Conditionally hide based on search state -->
        <div class="headline" *ngIf="!searchComp?.searchActive()" style="display: flex; align-content: center;">
            <app-user-icon *ngIf="avatar()" [type]="'xs'" [img_url]="avatar().img_url" [etat_cont]="avatar().etat_cont" [can_access]="avatar().phase != 'code' ? (avatar().can_access !== null ? false : null) :avatar().can_access" [block_status]="avatar().account_status" style="margin-inline-end: -8px;"></app-user-icon>
            <div 
                class="title-container" 
                [class.date-title-clickable]="isDateTitle()" 
                [newFeatureStyling]="isDateTitle() ? 'R02-CalendarSmallScreen-Datepicker' : null" 
                [newFeatureStylingFamily]="isDateTitle() ? 'R2-CalendarNewFeatures' : null"
                [newFeatureStylingStep]="isDateTitle() ? 4 : null"
                (click)="onTitleClick()"
            >
                <span class="title-large title-text" [ngClass]="{'title-medium': !!badge()?.length || isDateTitle()}">
                    {{ mobileHeaderTitle() }}
                </span>
                <mat-icon *ngIf="isDateTitle()" class="date-title-dropdown-icon" aria-hidden="true">arrow_drop_down</mat-icon>
                <div *ngIf="badge()?.length" style="display:flex; width: fit-content; gap: 4px;">
                    @for (badge of badge(); track $index) {
                        <span class="label-small">{{ badge === 'Agent bureau' ? ('permissions.Agent bureau' | transloco) : (badge === 'administrateur' ? ('permissions.administrateur' | transloco) : (badge === 'moniteur' ? ('permissions.moniteur' | transloco) : badge)) }}</span>
                    }
                </div>
            </div>

            <!-- Hidden touch-UI datepicker for small screen calendar date selection -->
            <input
                matInput
                [matDatepicker]="mobileDatePicker"
                [value]="mobilePickerDate"
                (dateChange)="onMobileDateSelected($event.value)"
                class="hidden-date-input"
            />
            <mat-datepicker #mobileDatePicker [touchUi]="true"></mat-datepicker>
        </div>

        <!-- Search Component Wrapper: Always present, controls its content -->
        <!-- Add 'active' class to allow flex-grow or other structural changes via CSS -->
        <div class="search-wrapper" *ngIf="showSearchIcon()"  [class.active]="searchComp?.searchActive()">
            <!-- Use #searchComp template ref var, listen for 'search' output event -->
            <aep-search #searchComp ></aep-search>
        </div>


        <!-- Trailing Icons: Conditionally hide based on search state -->
        <!-- The search trigger icon is now INSIDE aep-search -->
        <div class="trailing-icons" *ngIf="!searchComp?.searchActive()">
            @if (showCustomActions()) {
                <ng-container *ngFor="let action of customActions()">
                    <ng-container *ngIf="!(isBulkMobileActive() && action.icon === 'view_list')">
                    <ng-container *ngIf="isBulkMobileActive() && action.id === 'moreOptions'; else nonBulkActionTemplate">
                        <button mat-flat-button color="primary" class="bulk-save-button" (click)="triggerBulkSave()">
                            {{ 'calender.Enregistrer' | transloco }}
                        </button>
                    </ng-container>

                    <ng-template #nonBulkActionTemplate>
                    <!-- Three-dot menu for actions with subActions -->
                    <ng-container *ngIf="action.subActions?.length; else regularAction">
                        <button mat-icon-button
                               [matMenuTriggerFor]="moreOptionsMenu"
                               class="normalized-button"
                               [matTooltip]="action.label">
                            <mat-icon 
                            [svgIcon]="'mat_outline:' + action.icon"
                            ></mat-icon>
                        </button>
                        <mat-menu #moreOptionsMenu="matMenu" class="more-options-menu">
                            <button mat-menu-item *ngFor="let sub of action.subActions" (click)="doItemAction(sub.action)">
                                <mat-icon [svgIcon]="'mat_outline:' + sub.icon"></mat-icon>
                                <span>{{ sub.labelKey ? (sub.labelKey | transloco) : sub.label }}</span>
                            </button>
                        </mat-menu>
                    </ng-container>
                    <!-- Regular icon button -->
                    <ng-template #regularAction>
                        <button mat-icon-button 
                               [matTooltip]="action.label" 
                               (click)="doItemAction(action.action)" 
                               [matMenuTriggerFor]="action.action === 'openViewMenu' ? viewMenu : null"
                               class="normalized-button">
                            <mat-icon [svgIcon]="'mat_outline:' + action.icon"
                            [newFeatureStyling]="action.newFeatureStylingRef || null"
                            [newFeatureStylingFamily]="action.newFeatureStylingFamily || null"
                            [newFeatureStylingStep]="action.newFeatureStylingStep || null"
                            ></mat-icon>
                        </button>
                    </ng-template>
                    </ng-template>
                    </ng-container>
                </ng-container>
            }
            <aep-filter *ngIf="showFilterToggle()"></aep-filter>
            <aep-notifications *ngIf="showNotificationToggle()"></aep-notifications>
            
            <!-- View Menu -->
            <mat-menu #viewMenu="matMenu" class="custom-menu-divider" >
                <ng-container *ngIf="viewOptions$ | async as viewOptions">
                    <button class="view-button" *ngFor="let option of viewOptions" mat-menu-item (click)="changeView(option.id)">
                                <span>{{ option.title | transloco }}</span>
                            <mat-icon *ngIf="_calendarService.viewModeSignal() === option.id">check</mat-icon>
                    </button>
                    
                    <mat-divider></mat-divider>
                    <button class="view-button" mat-menu-item (click)="changeView('agents')"
                    [newFeatureStyling]="'R02-CalendarView-AgentView'" newFeatureStylingFamily="R2-CalendarNewFeatures" [newFeatureStylingStep]="2">
                                <span>{{ 'calender.by_instructor' | transloco }}</span>
                            @if(_calendarService.viewModeSignal() === 'agents'){
                                <mat-icon>check</mat-icon>
                            }
                    </button>
                </ng-container>
            </mat-menu>
        </div>
    </div>

    <!-- Page Tabs: Also hide when search is active -->
    <aep-page-mode-tab *ngIf="showPageTabMode() && !searchComp?.searchActive()"></aep-page-mode-tab>

</div>
